import React, { useEffect, useState } from "react";
import ItemImagePicker from "@components/item/ItemImagePicker";
import useScrollReset from "@hooks/ScrollHook";
import { AttributeInputs } from "@components/AttributesInputs";
import { useAccount } from "@contexts/AccountContext";
import { useSelectedChain } from "@app/examples/ChainSelector";
import { useApi } from "@hooks/ApiHook";
import ItemJsonPicker from "@components/item/ItemJsonPicker";
import useAlert from "@hooks/AlertHook";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { useNavigate, useParams } from "react-router-dom";

function EditItemPage() {
    useScrollReset()

    const { id } = useParams();
    const navigate = useNavigate()
    const alert = useAlert()
    const baaangggg = useBaaanggg()

    const [attributes, setAttributes] = useState<{ type: string, value: string }[]>([])
    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [image, setImage] = useState<File>()
    const { data: item } = useApi(async api => api.item.find(id!))
    const { data: traits } = useApi(async api => api.item.itemTraits(id!))

    useEffect(() => {
        if (item) {
            setName(item.name)
            setDescription(item.description ?? "")
        }
    }, [item])

    useEffect(() => {
        if (traits) {
            setAttributes(traits.map(e => ({
                type: e.traitType ?? "Unknown type",
                value: e.value ?? "Unknown value"
            })))
        }
    }, [traits])

    const onJsonPick = (json: { name: string, description?: string, attributes?: { trait_type: string, value: string }[] }) => {
        setName(json.name)
        if (json.description) setDescription(json.description)
        if (json.attributes) setAttributes(json.attributes.map(e => ({ type: e.trait_type, value: e.value })))
    }

    const onSubmit = async () => {
        try {
            alert.loading("Updating Item")
            const updatedItem = await baaangggg.item.update(id!, {
                image: image,
                name: name,
                description: description,
                traits: attributes.map(e => ({ traitType: e.type, value: e.value }))
            })
            alert.success("Item updated successfully")
            navigate(`/item/${updatedItem.id}`)
        } catch (e) {
            if (e instanceof Error) alert.failed(`Cannot update item, reason: ${e.message}`)
            else console.log(e)
        }
    }

    return <>
        <main>
            <section className="relative py-24">
                <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
                    <img src="img/gradient_light.jpg"
                        alt="gradient"
                        className="h-full w-full" />
                </picture>
                <div className="container">
                    <h1 className="py-16 text-center font-display text-4xl font-medium text-jacarta-700 dark:text-jacarta-500">Create NFT</h1>

                    <div className="mx-auto max-w-[48.125rem]">
                        <ItemImagePicker url={item?.image} onChange={value => setImage(value)} />

                        <ItemJsonPicker onChange={object => onJsonPick(object as any)} />

                        <div className="mb-6">
                            <label htmlFor="item-name"
                                className="mb-2 block font-display text-jacarta-700 dark:text-white">Name</label>
                            <input
                                value={name}
                                onChange={({ target }) => setName(target.value)}
                                type="text"
                                id="item-name"
                                className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                placeholder="Item name"
                                required />
                        </div>

                        <div className="mb-6">
                            <label htmlFor="item-description"
                                className="mb-2 block font-display text-jacarta-700 dark:text-white">Description</label>
                            <p className="mb-3 text-2xs dark:text-gray-400">
                                The description will be included on the item's detail page underneath its image
                            </p>
                            <textarea
                                value={description}
                                onChange={({ target }) => setDescription(target.value)}
                                id="item-description"
                                className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                rows={4}
                                required
                                placeholder="Provide a detailed description of your item."></textarea>
                        </div>

                        <div className="mb-6">
                            <label className="mb-2 block font-display text-jacarta-700 dark:text-white">Traits</label>
                            <AttributeInputs attributes={attributes} onChange={attributes => setAttributes(attributes)} />
                        </div>

                        <button
                            onClick={onSubmit}
                            className="rounded-full bg-jacarta-500 py-3 px-8 text-center font-semibold text-white transition-all hover:bg-jacarta-600">
                            Update
                        </button>
                    </div>
                </div>
            </section>
        </main>
    </>
}

export default EditItemPage;